import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=3c983b88"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports